import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";
import { round, toCents } from "@/utils/numberUtils";

export class AddStockRecordDto {
  @Expose()
  consumableId: string;

  @Expose()
  warehouseId: string;

  @Expose()
  locationId: string;

  @Transform(({ value }) => parseAppDate(value, false))
  @Expose()
  date: string;

  @Expose()
  @Type(() => Number)
  quantity: number;

  @Expose()
  @Type(() => Number)
  @Transform(({ value }) => toCents(round(value, 2)))
  unitCost: number;

  @Expose()
  deliveryNoteId: string;

  @Expose()
  supplierId: string;

  @Expose()
  description: string;
}
